/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';

/**
 * Checks that text is plaintext.
 * Creates a custom file count validation rule.
 * @author Jonny Cook <jcook@frontier.co.uk>
 */

export const Plaintext: object = {
    /**
     * @param {string} field
     * @param args
     * @return {string}
     */
    getMessage(field: any, args: number[]|null): string {
        return Vue.i18n.translate('validator.plaintext.error',
            {count: !!args ? args[0] : ''}) ||
            'Invalid character(s) entered';
    },

    /**
     * @param {string | null} value
     * @return {boolean}
     */
    validate(value: string|null): boolean {
        if (undefined === value || null === value) {
            return true;
        }

        return !value.match(/[`~!@#^&*|;<>\{\}\[\]\\]/);
    },
};
